<div
  #header
  class="header-container"
  [class.show-border]="!hideHeader || showroom"
>
  <div class="header-content">
    <app-banner
      [configs]="bannerConfigs"
      *ngIf="hasBannerConfigs && !hideBanner"
    ></app-banner>
    <div
      *ngIf="!hideHeader"
      class="header"
      [class.side-padding]="sidePadding"
    >
      <div class="left">
        <a
          class="logo"
          [href]="homeUrl"
          merriNoFocusLink
          rel="noopener nofollow noreferrer"
          target="_blank"
          (click)="onLogoClick()"
        >
          <img
            [src]="brandingService.logoUrl()"
            class="title-image"
            imgErrLog
          />
        </a>
      </div>
      <app-public-header
        class="right header-component"
        *ngIf="loggedOut"
      ></app-public-header>
      <app-protected-header
        class="right header-component"
        *ngIf="user"
        [user]="user"
      ></app-protected-header>
    </div>

    <app-showroom-header
      class="showroom header"
      *ngIf="hideHeader && showroom"
      [showroom]="showroom"
    ></app-showroom-header>
  </div>
</div>
<div
  #drawerContainer
  class="header-drawer-container"
  animate.leave="collapse"
  *ngIf="headerDrawer"
>
  <div class="header-drawer-content">
    <ng-container *ngTemplateOutlet="headerDrawer"></ng-container>
  </div>
</div>
